import { render, staticRenderFns } from "./collect-list.vue?vue&type=template&id=41de42bd&scoped=true&"
import script from "./collect-list.js?vue&type=script&lang=js&"
export * from "./collect-list.js?vue&type=script&lang=js&"
import style0 from "./collect-list.vue?vue&type=style&index=0&id=41de42bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de42bd",
  null
  
)

export default component.exports